module.exports = __webpack_public_path__ + "static/media/studies_img_two.7ad1e987.jpg";